var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "#FF6B00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.75 2.25203V15.75C55.75 16.8546 54.8546 17.75 53.75 17.75C52.6454 17.75 51.75 16.8546 51.75 15.75V7.0785L39.3341 19.4944C42.5592 23.3552 44.5 28.326 44.5 33.75C44.5 46.0383 34.5383 56 22.25 56C9.96166 56 0 46.0383 0 33.75C0 21.4617 9.96166 11.5 22.25 11.5C27.6741 11.5 32.6448 13.4409 36.5056 16.666L48.9216 4.25H40.25C39.1454 4.25 38.25 3.35457 38.25 2.25C38.25 1.14543 39.1454 0.25 40.25 0.25H53.75C54.0493 0.25 54.3332 0.315734 54.5881 0.433552C54.7568 0.511343 54.9168 0.613873 55.0628 0.741136C55.2859 0.935426 55.4655 1.17839 55.5851 1.45349C55.6897 1.69409 55.7483 1.95926 55.75 2.23794C55.75 2.24196 55.75 2.24598 55.75 2.25V2.25203ZM22.25 15.5C27.285 15.5 31.8439 17.539 35.1457 20.8364L35.1547 20.8454L35.1637 20.8543C38.461 24.1562 40.5 28.715 40.5 33.75C40.5 43.8292 32.3292 52 22.25 52C12.1708 52 4 43.8292 4 33.75C4 23.6708 12.1708 15.5 22.25 15.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male-icon.6ac190c2463750292ba1986a89e61f66.svg";
export { ForwardRef as ReactComponent };